<template>
  <div
    id="goTotop"
    title="Go to top"
    :style="{ display: isButtonVisible ? 'block' : 'none' }"
    @click="scrollToTop"
  >
    <div class="goo-top-box">
      <img class="go-top" :src="$getThemeImagePath('icon-top-arrow.svg')">
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isButtonVisible: false
    }
  },
  computed: {

  },
  created() {

  },
  mounted() {
    const content = this.$parent.$refs.content
    window.addEventListener('scroll', this.handleScroll)
    if (content) {
      content.addEventListener('scroll', this.handleScroll)
    }
  },
  beforeDestroy() {
    const content = this.$parent.$refs.content
    window.removeEventListener('scroll', this.handleScroll)
    if (content) {
      content.removeEventListener('scroll', this.handleScroll)
    }
  },
  methods: {
    handleScroll() {
      if (window.scrollY === 0) {
        this.isButtonVisible = false
      } else {
        this.isButtonVisible = true
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      this.isButtonVisible = false
    }
  }
}
</script>
